module.exports = __webpack_public_path__ + "static/media/beep.28f514cf.mp3";